module.exports = __webpack_public_path__ + "img/sixdots.d103ab9a.svg";